import BaseEvent from "../../util/baseEvent"
import axios from "axios"
// let logRemoteUrl = 'https://vk-logs.vipkid.com.cn/topics/qos-client-log';
export class HttpService extends BaseEvent {
  // 这里与vipkid-signal-sdk保存一致，增加secure参数，但是不做判断，仍然使用https
  constructor(secure = true) {
    super()
    this.protocol = "https"
    // if (!secure) this.protocol = 'http';
  }
  findIdcService(ep, excluded) {
    let params = {
      idcIp: ep,
      sessionId: this.sessionId
    }
    if (excluded && excluded.length > 0) {
      params["exclude"] = excluded
    }
    return axios(`${this.protocol}://${ep}/controller/findIdcService`, {
      params,
      timeout: 5000
    })
  }
  ping(ep, token, params = {}) {
    // ep+=1;
    return axios(`${this.protocol}://${ep}/controller/ping`, {
      timeout: 2000,
      cancelToken: token,
      params: Object.assign(params, {
        sessionId: this.sessionId
      })
    })
  }
  log(level, type, params) {
    params = Object.assign(
      {},
      {
        timestamp: new Date().getTime(),
        sessionId: this.sessionId,
        sdkType: 1,
        level,
        type // 错误类型 哪个步骤错误
      },
      params
    ) // 详细信息
  }
}
const apiService = new HttpService()
export default apiService
